// @ts-nocheck
import {
  buildNormalizedAliases,
  buildColumnMap,
  buildRecordFromColumnMap,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const ALICO_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  drugCode: ['제품코드'],
  drugName: ['제품'],
  unitPrice: ['보험약가'],
  quantity: ['판매수량'],
  prescriptionAmount: ['보험가'],
  feeRate: ['수수료(%)'],
  settlementAmount: ['정산금액'],
  note: ['정산수수료(%)'],
};

const REQUIRED_HEADERS = [
  '거래처코드',
  '처방처명',
  '제약사명',
  '제품코드',
  '제품',
  '보험약가',
  '수수료(%)',
  '보험가',
  '판매수량',
  '정산수수료(%)',
  '정산금액',
];

function isAlicoProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const alicoPharmTemplate = {
  id: 'alico-pharm',
  name: '알리코제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isAlicoProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isAlicoProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(ALICO_FIELD_ALIASES),
    );
    const detectedPharmaceuticalCompany = '알리코제약';
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const productCode = cleanText(row[columnMap.drugCode]);
      if (!productCode) {
        return;
      }

      const record = buildRecordFromColumnMap({
        row,
        columnMap,
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default alicoPharmTemplate;
